export const ELITE_WAR_DEFAULT_LAYOUT_ID = "elite_map_open13";
export const ELITE_WAR_VIEWBOX = Object.freeze({ width: 100, height: 50 });

const RAW_LAYOUTS = [
  {
    id: "elite_map_open13",
    label: "Open Lane (13)",
    description: "13-stronghold open center variant.",
    leftSpawnY: 25,
    rightSpawnY: 25,
    leftBaseLinks: ["5", "1"],
    rightBaseLinks: ["13", "9"],
    nodes: [
      { id: "1", x: 18, y: 30 },
      { id: "2", x: 30, y: 42 },
      { id: "3", x: 30, y: 25 },
      { id: "4", x: 30, y: 12 },
      { id: "5", x: 18, y: 20 },
      { id: "6", x: 45, y: 38 },
      { id: "7", x: 50, y: 25 },
      { id: "8", x: 55, y: 12 },
      { id: "9", x: 82, y: 30 },
      { id: "10", x: 70, y: 38 },
      { id: "11", x: 70, y: 25 },
      { id: "12", x: 70, y: 8 },
      { id: "13", x: 82, y: 20 },
    ],
    edges: [
      ["1", "2"],
      ["1", "3"],
      ["2", "3"],
      ["2", "6"],
      ["3", "4"],
      ["3", "5"],
      ["3", "6"],
      ["3", "7"],
      ["3", "8"],
      ["4", "5"],
      ["4", "7"],
      ["4", "8"],
      ["6", "7"],
      ["7", "8"],
      ["6", "10"],
      ["6", "11"],
      ["7", "10"],
      ["7", "11"],
      ["8", "11"],
      ["8", "12"],
      ["9", "10"],
      ["9", "11"],
      ["10", "11"],
      ["11", "12"],
      ["11", "13"],
      ["12", "13"],
    ],
  },
  {
    id: "elite_map_grid15",
    label: "Grid Push (15)",
    description: "15-stronghold dense lane variant.",
    leftSpawnY: 25,
    rightSpawnY: 25,
    leftBaseLinks: ["2", "1"],
    rightBaseLinks: ["15", "14"],
    nodes: [
      { id: "1", x: 20, y: 30 },
      { id: "2", x: 20, y: 20 },
      { id: "3", x: 35, y: 35 },
      { id: "4", x: 35, y: 25 },
      { id: "5", x: 35, y: 14 },
      { id: "6", x: 50, y: 40 },
      { id: "7", x: 50, y: 32 },
      { id: "8", x: 50, y: 25 },
      { id: "9", x: 50, y: 18 },
      { id: "10", x: 50, y: 10 },
      { id: "11", x: 65, y: 35 },
      { id: "12", x: 65, y: 25 },
      { id: "13", x: 65, y: 14 },
      { id: "14", x: 80, y: 30 },
      { id: "15", x: 80, y: 20 },
    ],
    edges: [
      ["1", "2"],
      ["1", "3"],
      ["1", "4"],
      ["2", "4"],
      ["2", "5"],
      ["3", "4"],
      ["3", "6"],
      ["3", "7"],
      ["4", "5"],
      ["4", "7"],
      ["4", "8"],
      ["4", "9"],
      ["5", "9"],
      ["5", "10"],
      ["6", "7"],
      ["6", "11"],
      ["7", "8"],
      ["7", "11"],
      ["7", "12"],
      ["8", "9"],
      ["8", "12"],
      ["9", "10"],
      ["9", "12"],
      ["9", "13"],
      ["10", "13"],
      ["11", "12"],
      ["11", "14"],
      ["12", "13"],
      ["12", "14"],
      ["12", "15"],
      ["13", "15"],
      ["14", "15"],
    ],
  },
  {
    id: "elite_map_ring15",
    label: "Ring Bridge (15)",
    description: "15-stronghold outer ring variant.",
    leftSpawnY: 25,
    rightSpawnY: 25,
    leftBaseLinks: ["3", "2", "1"],
    rightBaseLinks: ["15", "14", "13"],
    nodes: [
      { id: "1", x: 18, y: 40 },
      { id: "2", x: 18, y: 25 },
      { id: "3", x: 18, y: 10 },
      { id: "4", x: 40, y: 45 },
      { id: "5", x: 35, y: 32.5 },
      { id: "6", x: 35, y: 17.5 },
      { id: "7", x: 40, y: 5 },
      { id: "8", x: 50, y: 25 },
      { id: "9", x: 60, y: 45 },
      { id: "10", x: 65, y: 32.5 },
      { id: "11", x: 65, y: 17.5 },
      { id: "12", x: 60, y: 5 },
      { id: "13", x: 82, y: 40 },
      { id: "14", x: 82, y: 25 },
      { id: "15", x: 82, y: 10 },
    ],
    edges: [
      ["1", "2"],
      ["1", "4"],
      ["1", "5"],
      ["2", "3"],
      ["2", "5"],
      ["2", "6"],
      ["3", "6"],
      ["3", "7"],
      ["4", "5"],
      ["4", "9"],
      ["4", "9"],
      ["5", "6"],
      ["5", "8"],
      ["6", "7"],
      ["6", "8"],
      ["7", "12"],
      ["8", "10"],
      ["8", "11"],
      ["9", "10"],
      ["9", "13"],
      ["10", "11"],
      ["10", "13"],
      ["10", "14"],
      ["11", "12"],
      ["11", "14"],
      ["11", "15"],
      ["12", "15"],
      ["13", "14"],
      ["14", "15"],
    ],
  },
];

function normalizeEdges(edges = []) {
  const seen = new Set();
  const out = [];
  edges.forEach((pair) => {
    const left = String(pair?.[0] || "").trim();
    const right = String(pair?.[1] || "").trim();
    if (!left || !right || left === right) return;
    const key = [left, right].sort((a, b) => Number(a) - Number(b)).join("-");
    if (seen.has(key)) return;
    seen.add(key);
    out.push([left, right]);
  });
  return out;
}

function normalizeLayout(layout = {}) {
  const nodes = Array.isArray(layout.nodes)
    ? layout.nodes.map((node) => ({
      id: String(node?.id || "").trim(),
      label: String(node?.id || "").trim(),
      x: Number(node?.x || 0),
      y: Number(node?.y || 0),
    }))
    : [];

  const nodeIds = new Set(nodes.map((node) => node.id).filter(Boolean));
  const edges = normalizeEdges(layout.edges).filter(
    ([left, right]) => nodeIds.has(left) && nodeIds.has(right),
  );

  return {
    id: String(layout.id || "").trim(),
    label: String(layout.label || "").trim(),
    description: String(layout.description || "").trim(),
    leftSpawnLabel: String(layout.leftSpawnLabel || ""),
    rightSpawnLabel: String(layout.rightSpawnLabel || ""),
    leftSpawnY: Number(layout.leftSpawnY || 31),
    rightSpawnY: Number(layout.rightSpawnY || 31),
    leftBaseLinks: Array.isArray(layout.leftBaseLinks)
      ? layout.leftBaseLinks.map((nodeId) => String(nodeId || "").trim()).filter((nodeId) => nodeIds.has(nodeId))
      : [],
    rightBaseLinks: Array.isArray(layout.rightBaseLinks)
      ? layout.rightBaseLinks.map((nodeId) => String(nodeId || "").trim()).filter((nodeId) => nodeIds.has(nodeId))
      : [],
    nodes: nodes.filter((node) => node.id),
    edges,
  };
}

export const ELITE_WAR_LAYOUTS = Object.freeze(
  RAW_LAYOUTS.map((layout) => normalizeLayout(layout)),
);

export function getEliteWarLayoutById(layoutId = "") {
  const normalizedLayoutId = String(layoutId || "").trim();
  return (
    ELITE_WAR_LAYOUTS.find((layout) => layout.id === normalizedLayoutId)
    || ELITE_WAR_LAYOUTS.find((layout) => layout.id === ELITE_WAR_DEFAULT_LAYOUT_ID)
    || ELITE_WAR_LAYOUTS[0]
    || null
  );
}

export function isEliteWarLayoutId(layoutId = "") {
  const normalizedLayoutId = String(layoutId || "").trim();
  return ELITE_WAR_LAYOUTS.some((layout) => layout.id === normalizedLayoutId);
}
